module.exports = __webpack_public_path__ + "img/2.67b9fe29.png";